/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Notification.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query'
import type {
  AnonymousNotificationModel,
  GetNotificationGetLastNotificationDateParams,
  NotificationPreference,
  NotificationSendDiagnostic,
  NotificationTypeConfig,
  NotificationTypePreference,
  ObjectQueryResult,
  PostNotificationGenerateScheduleOccurrencesParams,
  PostNotificationGetUserPreferenceByIdParams,
  PostNotificationRetrieveByIdParams,
  PostNotificationSaveCommunicationPreferenceParams,
  PostNotificationSaveMyNotificationOptionParams,
  PostNotificationSaveNotificationRecipientsParams,
  PostNotificationSaveParams,
  PostNotificationSendNotificationParams,
  PostNotificationSendUserDefinedNotificationParams,
  PostNotificationUpsertLastNotificationDateParams,
  PostNotificationValidateInviteCodeParams,
  Query,
  QueuedNotification,
  ScheduleDefinition,
  UdAlertConditionEvaluationRequest,
  UdEvaluatedAlertCondition,
  UserDefinedNotification,
  UserDefinedNotificationRecipient,
  UserDefinedNotificationRequest,
  UserDefinedNotificationStatusUpdate
} from './Notification/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postNotificationSave = (
    params?: PostNotificationSaveParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<QueuedNotification>(
      {url: `/Notification/Save`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSaveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSave>>, TError,{params?: PostNotificationSaveParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSave>>, TError,{params?: PostNotificationSaveParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSave>>, {params?: PostNotificationSaveParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationSave(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSave>>>
    
    export type PostNotificationSaveMutationError = unknown

    export const usePostNotificationSave = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSave>>, TError,{params?: PostNotificationSaveParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSave>>,
        TError,
        {params?: PostNotificationSaveParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationSaveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationRetrieveById = (
    params?: PostNotificationRetrieveByIdParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<QueuedNotification[]>(
      {url: `/Notification/RetrieveById`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationRetrieveByIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationRetrieveById>>, TError,{params?: PostNotificationRetrieveByIdParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationRetrieveById>>, TError,{params?: PostNotificationRetrieveByIdParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationRetrieveById>>, {params?: PostNotificationRetrieveByIdParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationRetrieveById(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationRetrieveByIdMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationRetrieveById>>>
    
    export type PostNotificationRetrieveByIdMutationError = unknown

    export const usePostNotificationRetrieveById = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationRetrieveById>>, TError,{params?: PostNotificationRetrieveByIdParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationRetrieveById>>,
        TError,
        {params?: PostNotificationRetrieveByIdParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationRetrieveByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationRetrieveAll = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<QueuedNotification[]>(
      {url: `/Notification/RetrieveAll`, method: 'POST'
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationRetrieveAllMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationRetrieveAll>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationRetrieveAll>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationRetrieveAll>>, void> = () => {
          

          return  postNotificationRetrieveAll(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationRetrieveAllMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationRetrieveAll>>>
    
    export type PostNotificationRetrieveAllMutationError = unknown

    export const usePostNotificationRetrieveAll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationRetrieveAll>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationRetrieveAll>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostNotificationRetrieveAllMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationGetUserPreferenceById = (
    params?: PostNotificationGetUserPreferenceByIdParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<NotificationPreference>(
      {url: `/Notification/GetUserPreferenceById`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationGetUserPreferenceByIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationGetUserPreferenceById>>, TError,{params?: PostNotificationGetUserPreferenceByIdParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationGetUserPreferenceById>>, TError,{params?: PostNotificationGetUserPreferenceByIdParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationGetUserPreferenceById>>, {params?: PostNotificationGetUserPreferenceByIdParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationGetUserPreferenceById(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationGetUserPreferenceByIdMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationGetUserPreferenceById>>>
    
    export type PostNotificationGetUserPreferenceByIdMutationError = unknown

    export const usePostNotificationGetUserPreferenceById = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationGetUserPreferenceById>>, TError,{params?: PostNotificationGetUserPreferenceByIdParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationGetUserPreferenceById>>,
        TError,
        {params?: PostNotificationGetUserPreferenceByIdParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationGetUserPreferenceByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationValidateInviteCode = (
    params?: PostNotificationValidateInviteCodeParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Notification/ValidateInviteCode`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationValidateInviteCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationValidateInviteCode>>, TError,{params?: PostNotificationValidateInviteCodeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationValidateInviteCode>>, TError,{params?: PostNotificationValidateInviteCodeParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationValidateInviteCode>>, {params?: PostNotificationValidateInviteCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationValidateInviteCode(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationValidateInviteCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationValidateInviteCode>>>
    
    export type PostNotificationValidateInviteCodeMutationError = unknown

    export const usePostNotificationValidateInviteCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationValidateInviteCode>>, TError,{params?: PostNotificationValidateInviteCodeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationValidateInviteCode>>,
        TError,
        {params?: PostNotificationValidateInviteCodeParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationValidateInviteCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationSendNotification = (
    anonymousNotificationModel: AnonymousNotificationModel,
    params?: PostNotificationSendNotificationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Notification/SendNotification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: anonymousNotificationModel,
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSendNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSendNotification>>, TError,{data: AnonymousNotificationModel;params?: PostNotificationSendNotificationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSendNotification>>, TError,{data: AnonymousNotificationModel;params?: PostNotificationSendNotificationParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSendNotification>>, {data: AnonymousNotificationModel;params?: PostNotificationSendNotificationParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postNotificationSendNotification(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSendNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSendNotification>>>
    export type PostNotificationSendNotificationMutationBody = AnonymousNotificationModel
    export type PostNotificationSendNotificationMutationError = unknown

    export const usePostNotificationSendNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSendNotification>>, TError,{data: AnonymousNotificationModel;params?: PostNotificationSendNotificationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSendNotification>>,
        TError,
        {data: AnonymousNotificationModel;params?: PostNotificationSendNotificationParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationSendNotificationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationSaveCommunicationPreference = (
    params?: PostNotificationSaveCommunicationPreferenceParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Notification/SaveCommunicationPreference`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSaveCommunicationPreferenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveCommunicationPreference>>, TError,{params?: PostNotificationSaveCommunicationPreferenceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveCommunicationPreference>>, TError,{params?: PostNotificationSaveCommunicationPreferenceParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSaveCommunicationPreference>>, {params?: PostNotificationSaveCommunicationPreferenceParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationSaveCommunicationPreference(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSaveCommunicationPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSaveCommunicationPreference>>>
    
    export type PostNotificationSaveCommunicationPreferenceMutationError = unknown

    export const usePostNotificationSaveCommunicationPreference = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveCommunicationPreference>>, TError,{params?: PostNotificationSaveCommunicationPreferenceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSaveCommunicationPreference>>,
        TError,
        {params?: PostNotificationSaveCommunicationPreferenceParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationSaveCommunicationPreferenceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNotificationGetNotificationTypeConfigs = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<NotificationTypeConfig[]>(
      {url: `/Notification/GetNotificationTypeConfigs`, method: 'GET', signal
    },
      { type: 'Notification',  ...options});
    }
  

export const getGetNotificationGetNotificationTypeConfigsQueryKey = () => {
    return [`/Notification/GetNotificationTypeConfigs`] as const;
    }

    
export const getGetNotificationGetNotificationTypeConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationGetNotificationTypeConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>> = ({ signal }) => getNotificationGetNotificationTypeConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationGetNotificationTypeConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>>
export type GetNotificationGetNotificationTypeConfigsQueryError = unknown

export const useGetNotificationGetNotificationTypeConfigs = <TData = Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetNotificationTypeConfigs>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationGetNotificationTypeConfigsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNotificationGenerateScheduleOccurrences = (
    scheduleDefinition: ScheduleDefinition,
    params?: PostNotificationGenerateScheduleOccurrencesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string[]>(
      {url: `/Notification/GenerateScheduleOccurrences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleDefinition,
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationGenerateScheduleOccurrencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationGenerateScheduleOccurrences>>, TError,{data: ScheduleDefinition;params?: PostNotificationGenerateScheduleOccurrencesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationGenerateScheduleOccurrences>>, TError,{data: ScheduleDefinition;params?: PostNotificationGenerateScheduleOccurrencesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationGenerateScheduleOccurrences>>, {data: ScheduleDefinition;params?: PostNotificationGenerateScheduleOccurrencesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postNotificationGenerateScheduleOccurrences(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationGenerateScheduleOccurrencesMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationGenerateScheduleOccurrences>>>
    export type PostNotificationGenerateScheduleOccurrencesMutationBody = ScheduleDefinition
    export type PostNotificationGenerateScheduleOccurrencesMutationError = unknown

    export const usePostNotificationGenerateScheduleOccurrences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationGenerateScheduleOccurrences>>, TError,{data: ScheduleDefinition;params?: PostNotificationGenerateScheduleOccurrencesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationGenerateScheduleOccurrences>>,
        TError,
        {data: ScheduleDefinition;params?: PostNotificationGenerateScheduleOccurrencesParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationGenerateScheduleOccurrencesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationEvaluateAlertCondition = (
    udAlertConditionEvaluationRequest: UdAlertConditionEvaluationRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<UdEvaluatedAlertCondition>(
      {url: `/Notification/EvaluateAlertCondition`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: udAlertConditionEvaluationRequest
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationEvaluateAlertConditionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationEvaluateAlertCondition>>, TError,{data: UdAlertConditionEvaluationRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationEvaluateAlertCondition>>, TError,{data: UdAlertConditionEvaluationRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationEvaluateAlertCondition>>, {data: UdAlertConditionEvaluationRequest}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationEvaluateAlertCondition(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationEvaluateAlertConditionMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationEvaluateAlertCondition>>>
    export type PostNotificationEvaluateAlertConditionMutationBody = UdAlertConditionEvaluationRequest
    export type PostNotificationEvaluateAlertConditionMutationError = unknown

    export const usePostNotificationEvaluateAlertCondition = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationEvaluateAlertCondition>>, TError,{data: UdAlertConditionEvaluationRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationEvaluateAlertCondition>>,
        TError,
        {data: UdAlertConditionEvaluationRequest},
        TContext
      > => {

      const mutationOptions = getPostNotificationEvaluateAlertConditionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNotificationGetLastNotificationDate = (
    params?: GetNotificationGetLastNotificationDateParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/Notification/GetLastNotificationDate`, method: 'GET',
        params, signal
    },
      { type: 'Notification',  ...options});
    }
  

export const getGetNotificationGetLastNotificationDateQueryKey = (params?: GetNotificationGetLastNotificationDateParams,) => {
    return [`/Notification/GetLastNotificationDate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNotificationGetLastNotificationDateQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>, TError = unknown>(params?: GetNotificationGetLastNotificationDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationGetLastNotificationDateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>> = ({ signal }) => getNotificationGetLastNotificationDate(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationGetLastNotificationDateQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>>
export type GetNotificationGetLastNotificationDateQueryError = unknown

export const useGetNotificationGetLastNotificationDate = <TData = Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>, TError = unknown>(
 params?: GetNotificationGetLastNotificationDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetLastNotificationDate>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationGetLastNotificationDateQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNotificationUpsertLastNotificationDate = (
    params?: PostNotificationUpsertLastNotificationDateParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Notification/UpsertLastNotificationDate`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationUpsertLastNotificationDateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationUpsertLastNotificationDate>>, TError,{params?: PostNotificationUpsertLastNotificationDateParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationUpsertLastNotificationDate>>, TError,{params?: PostNotificationUpsertLastNotificationDateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationUpsertLastNotificationDate>>, {params?: PostNotificationUpsertLastNotificationDateParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationUpsertLastNotificationDate(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationUpsertLastNotificationDateMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationUpsertLastNotificationDate>>>
    
    export type PostNotificationUpsertLastNotificationDateMutationError = unknown

    export const usePostNotificationUpsertLastNotificationDate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationUpsertLastNotificationDate>>, TError,{params?: PostNotificationUpsertLastNotificationDateParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationUpsertLastNotificationDate>>,
        TError,
        {params?: PostNotificationUpsertLastNotificationDateParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationUpsertLastNotificationDateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationSaveMyNotificationOption = (
    params?: PostNotificationSaveMyNotificationOptionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Notification/SaveMyNotificationOption`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSaveMyNotificationOptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveMyNotificationOption>>, TError,{params?: PostNotificationSaveMyNotificationOptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveMyNotificationOption>>, TError,{params?: PostNotificationSaveMyNotificationOptionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSaveMyNotificationOption>>, {params?: PostNotificationSaveMyNotificationOptionParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationSaveMyNotificationOption(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSaveMyNotificationOptionMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSaveMyNotificationOption>>>
    
    export type PostNotificationSaveMyNotificationOptionMutationError = unknown

    export const usePostNotificationSaveMyNotificationOption = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveMyNotificationOption>>, TError,{params?: PostNotificationSaveMyNotificationOptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSaveMyNotificationOption>>,
        TError,
        {params?: PostNotificationSaveMyNotificationOptionParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationSaveMyNotificationOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNotificationGetMyNotificationTypePreferences = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<NotificationTypePreference[]>(
      {url: `/Notification/GetMyNotificationTypePreferences`, method: 'GET', signal
    },
      { type: 'Notification',  ...options});
    }
  

export const getGetNotificationGetMyNotificationTypePreferencesQueryKey = () => {
    return [`/Notification/GetMyNotificationTypePreferences`] as const;
    }

    
export const getGetNotificationGetMyNotificationTypePreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationGetMyNotificationTypePreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>> = ({ signal }) => getNotificationGetMyNotificationTypePreferences(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationGetMyNotificationTypePreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>>
export type GetNotificationGetMyNotificationTypePreferencesQueryError = unknown

export const useGetNotificationGetMyNotificationTypePreferences = <TData = Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationGetMyNotificationTypePreferences>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationGetMyNotificationTypePreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNotificationGetMyUserDefinedNotifications = (
    userDefinedNotificationRequest: UserDefinedNotificationRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<UserDefinedNotification[]>(
      {url: `/Notification/GetMyUserDefinedNotifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userDefinedNotificationRequest
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationGetMyUserDefinedNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationGetMyUserDefinedNotifications>>, TError,{data: UserDefinedNotificationRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationGetMyUserDefinedNotifications>>, TError,{data: UserDefinedNotificationRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationGetMyUserDefinedNotifications>>, {data: UserDefinedNotificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationGetMyUserDefinedNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationGetMyUserDefinedNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationGetMyUserDefinedNotifications>>>
    export type PostNotificationGetMyUserDefinedNotificationsMutationBody = UserDefinedNotificationRequest
    export type PostNotificationGetMyUserDefinedNotificationsMutationError = unknown

    export const usePostNotificationGetMyUserDefinedNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationGetMyUserDefinedNotifications>>, TError,{data: UserDefinedNotificationRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationGetMyUserDefinedNotifications>>,
        TError,
        {data: UserDefinedNotificationRequest},
        TContext
      > => {

      const mutationOptions = getPostNotificationGetMyUserDefinedNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationQueryMyUserDefinedNotifications = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/Notification/QueryMyUserDefinedNotifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationQueryMyUserDefinedNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationQueryMyUserDefinedNotifications>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationQueryMyUserDefinedNotifications>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationQueryMyUserDefinedNotifications>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationQueryMyUserDefinedNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationQueryMyUserDefinedNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationQueryMyUserDefinedNotifications>>>
    export type PostNotificationQueryMyUserDefinedNotificationsMutationBody = Query
    export type PostNotificationQueryMyUserDefinedNotificationsMutationError = unknown

    export const usePostNotificationQueryMyUserDefinedNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationQueryMyUserDefinedNotifications>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationQueryMyUserDefinedNotifications>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostNotificationQueryMyUserDefinedNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationSaveNotificationTypePreference = (
    notificationTypePreference: NotificationTypePreference,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<NotificationTypePreference>(
      {url: `/Notification/SaveNotificationTypePreference`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationTypePreference
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSaveNotificationTypePreferenceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveNotificationTypePreference>>, TError,{data: NotificationTypePreference}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveNotificationTypePreference>>, TError,{data: NotificationTypePreference}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSaveNotificationTypePreference>>, {data: NotificationTypePreference}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationSaveNotificationTypePreference(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSaveNotificationTypePreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSaveNotificationTypePreference>>>
    export type PostNotificationSaveNotificationTypePreferenceMutationBody = NotificationTypePreference
    export type PostNotificationSaveNotificationTypePreferenceMutationError = unknown

    export const usePostNotificationSaveNotificationTypePreference = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveNotificationTypePreference>>, TError,{data: NotificationTypePreference}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSaveNotificationTypePreference>>,
        TError,
        {data: NotificationTypePreference},
        TContext
      > => {

      const mutationOptions = getPostNotificationSaveNotificationTypePreferenceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationSaveNotificationRecipients = (
    userDefinedNotificationRecipient: UserDefinedNotificationRecipient[],
    params?: PostNotificationSaveNotificationRecipientsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Notification/SaveNotificationRecipients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userDefinedNotificationRecipient,
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSaveNotificationRecipientsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveNotificationRecipients>>, TError,{data: UserDefinedNotificationRecipient[];params?: PostNotificationSaveNotificationRecipientsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveNotificationRecipients>>, TError,{data: UserDefinedNotificationRecipient[];params?: PostNotificationSaveNotificationRecipientsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSaveNotificationRecipients>>, {data: UserDefinedNotificationRecipient[];params?: PostNotificationSaveNotificationRecipientsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postNotificationSaveNotificationRecipients(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSaveNotificationRecipientsMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSaveNotificationRecipients>>>
    export type PostNotificationSaveNotificationRecipientsMutationBody = UserDefinedNotificationRecipient[]
    export type PostNotificationSaveNotificationRecipientsMutationError = unknown

    export const usePostNotificationSaveNotificationRecipients = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSaveNotificationRecipients>>, TError,{data: UserDefinedNotificationRecipient[];params?: PostNotificationSaveNotificationRecipientsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSaveNotificationRecipients>>,
        TError,
        {data: UserDefinedNotificationRecipient[];params?: PostNotificationSaveNotificationRecipientsParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationSaveNotificationRecipientsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationUpdateUserDefinedNotification = (
    userDefinedNotificationStatusUpdate: UserDefinedNotificationStatusUpdate,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<UserDefinedNotification>(
      {url: `/Notification/UpdateUserDefinedNotification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userDefinedNotificationStatusUpdate
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationUpdateUserDefinedNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationUpdateUserDefinedNotification>>, TError,{data: UserDefinedNotificationStatusUpdate}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationUpdateUserDefinedNotification>>, TError,{data: UserDefinedNotificationStatusUpdate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationUpdateUserDefinedNotification>>, {data: UserDefinedNotificationStatusUpdate}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationUpdateUserDefinedNotification(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationUpdateUserDefinedNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationUpdateUserDefinedNotification>>>
    export type PostNotificationUpdateUserDefinedNotificationMutationBody = UserDefinedNotificationStatusUpdate
    export type PostNotificationUpdateUserDefinedNotificationMutationError = unknown

    export const usePostNotificationUpdateUserDefinedNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationUpdateUserDefinedNotification>>, TError,{data: UserDefinedNotificationStatusUpdate}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationUpdateUserDefinedNotification>>,
        TError,
        {data: UserDefinedNotificationStatusUpdate},
        TContext
      > => {

      const mutationOptions = getPostNotificationUpdateUserDefinedNotificationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNotificationSendUserDefinedNotification = (
    params?: PostNotificationSendUserDefinedNotificationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<NotificationSendDiagnostic>(
      {url: `/Notification/SendUserDefinedNotification`, method: 'POST',
        params
    },
      { type: 'Notification',  ...options});
    }
  


export const getPostNotificationSendUserDefinedNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSendUserDefinedNotification>>, TError,{params?: PostNotificationSendUserDefinedNotificationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationSendUserDefinedNotification>>, TError,{params?: PostNotificationSendUserDefinedNotificationParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationSendUserDefinedNotification>>, {params?: PostNotificationSendUserDefinedNotificationParams}> = (props) => {
          const {params} = props ?? {};

          return  postNotificationSendUserDefinedNotification(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationSendUserDefinedNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationSendUserDefinedNotification>>>
    
    export type PostNotificationSendUserDefinedNotificationMutationError = unknown

    export const usePostNotificationSendUserDefinedNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationSendUserDefinedNotification>>, TError,{params?: PostNotificationSendUserDefinedNotificationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationSendUserDefinedNotification>>,
        TError,
        {params?: PostNotificationSendUserDefinedNotificationParams},
        TContext
      > => {

      const mutationOptions = getPostNotificationSendUserDefinedNotificationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNotificationImagesImageIdPng = (
    imageId: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Notification/images/${imageId}.png`, method: 'GET', signal
    },
      { type: 'Notification',  ...options});
    }
  

export const getGetNotificationImagesImageIdPngQueryKey = (imageId: string,) => {
    return [`/Notification/images/${imageId}.png`] as const;
    }

    
export const getGetNotificationImagesImageIdPngQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>, TError = unknown>(imageId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationImagesImageIdPngQueryKey(imageId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>> = ({ signal }) => getNotificationImagesImageIdPng(imageId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(imageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationImagesImageIdPngQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>>
export type GetNotificationImagesImageIdPngQueryError = unknown

export const useGetNotificationImagesImageIdPng = <TData = Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>, TError = unknown>(
 imageId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationImagesImageIdPng>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationImagesImageIdPngQueryOptions(imageId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




